export const DuplicateShowToEvent = 'DuplicateShowToEvent';
export const ShowResetTimes = 'ShowResetTimes';
export const ShowColumnOrderReset = 'ShowColumnOrderReset';
export const MovedEventTemplateToTeam = 'MovedEventTemplateToTeam';

export default {
  DuplicateShowToEvent,
  ShowResetTimes,
  ShowColumnOrderReset,
  MovedEventTemplateToTeam
};
